import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class PartnersService {

  // Get partners list
  getPartners = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc') => {
    return await axios.get(API_URL + '/partners?page=' + pageNum + '&search=' + search + '&limit=' + limit + '&sortBy=' + sortBy + '&sortOrder=' + sortOrder, { headers: authHeader() })
  }

  // Add new partner
  addPartner = async (partner) => {
    return await axios.post(API_URL + '/partners', partner, { headers: authHeader() })
  }

  // Update partner data
  updatePartner = async (partner, id) => {
    return await axios.patch(API_URL + '/partners/' + id, partner, { headers: authHeader() })
  }

  // Get partner data
  getPartner = async (id) => {
    return await axios.get(API_URL + '/partners/' + id, { headers: authHeader() })
  }

  // Delete partner
  deletePartner = async (id) => {
    return await axios.delete(API_URL + '/partners/' + id, { headers: authHeader() })
  }

}

export default new PartnersService()